import { Component, OnInit, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LombardFacade } from '@zero/lombard/domain';
import { TransactionAuthorizationComponent } from '@zero/shared/ui-web-components';
import { ModalComponent } from '@zero/shared/ui-web-design-system';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { AuthPayloadTicket, AuthorizationData, Ticket, TicketData, TransactionAuthorizationResult } from '@zero/shared/util-models';

@Component({
  templateUrl: './lombard-cancel-modal.component.html',
  imports: [TranslocoPipe, TransactionAuthorizationComponent, ModalComponent],
})
export class LombardCancelModalComponent implements OnInit {
  public readonly modal = inject(NgbActiveModal);
  public readonly facade = inject(LombardFacade);

  readonly #customerStateFacade = inject(CustomerStateFacade);

  public authorizePayload: AuthorizationData<AuthPayloadTicket>;

  ngOnInit(): void {
    this.authorizePayload = this.#createTicket();
  }

  public handleTransactionAuthorization = (result: TransactionAuthorizationResult): void => {
    result.success && this.facade.loadLombard();
    this.modal.close();
  };

  #createTicket = (): AuthorizationData<AuthPayloadTicket> => {
    const ticket = new Ticket();
    ticket.customerId = this.#customerStateFacade.customerBaseData.customerId;
    ticket.type = 'CREDIT_DELETION';
    ticket.ticketData = new TicketData();
    ticket.ticketData.additionalProperties = {};
    return new AuthorizationData<AuthPayloadTicket>(new AuthPayloadTicket(ticket));
  };
}
